<template>
  <div class="div-input" :class="{ border: isFocus }">
    <div
      class="icon-circle otz-icon icon-otzar h-circle icon-search"
      @click="doFreeSearch1"
    >
      u
    </div>

    <div
      class="otz-icon icon-otzar no-bg icon-clear"
      :style="{
        left: showVirtualKeyBoard ? '55px' : '30px',
      }"
      v-if="!inputEmpty"
      @click="clearTxt"
    >
      F
    </div>
    <BaseIcon
      v-if="showVirtualKeyBoard"
      class="keyboard-icon"
      nameIcon="keyboard"
      pathIcon="k"
      :height="20"
      :width="20"
      v-tooltip="{
        content: $t('mainTools.keyboardOnScreen'),
        placement: 'right',
      }"
      @click="setVKB"
    />

    <input
      type="text"
      class="input-search"
      :class="{ mefo: mefo }"
      :style="{
        'padding-left': showVirtualKeyBoard ? '70px' : '45px',
      }"
      v-bind:placeholder="
        mefo
          ? $t('freeSearchInput.searchInMeforshim')
          : $t('freeSearchInput.placeHolder')
      "
      @keyup.enter.stop="doFreeSearch1"
      @keydown="scrollList"
      :value="getTextInput"
      @input="setSearchWords"
      @focus="toggleFocus()"
      @blur="toggleFocus()"
      ref="input"
      v-focus
      v-select.focus
    />
  </div>
</template>

<script>
import { createFreeSearchBookListStore } from "@/store_pinia";
import { mapActions, mapState, mapGetters } from "vuex";
import { saveSearchToHistory } from "@/services//history.js";
import {
  doFreeSearch,
  setSearchType,
  getBooksToSearchIn,
  clear,
} from "@/services/freeSearch.js";
import mixFreeSearch from "@/mixing/mixFreeSearch";
import mixInputCharsTranslate from "@/mixing/mixInputCharsTranslate";
// Add event listener to input focus

export default {
  sockets: {
    connect: function () {},
    freeSearchProgress: function ({ prog }) {
      this.setSearchProgress(prog);
    },
  },
  mixins: [mixFreeSearch, mixInputCharsTranslate],
  data() {
    return {
      // txtSearch: "",
      nameIcon: "icon-input-search",
      searchText: "",
      booksToSearch: [],
      isFocus: false,
      inputEmpty: true,

      text: "",
      cursorPosition: 0,
    };
  },
  props: {
    mefo: { default: false },
    searchId: { default: null },
  },
  computed: {
    ...mapGetters("freeSearch", ["getSearchWords"]),
    ...mapGetters("booklistComp", ["getListCheckBooks"]),
    ...mapGetters("freeSearchBooklistComp", ["getListCheckBooksFree"]),
    ...mapState("freeSearch", ["enumSearchInType"]),
    ...mapState("vKeyBoard", ["vKeyBoardInput", "vKeyBoardInputName"]),
    ...mapState("tabsManager", ["currentTabId"]),
    ...mapGetters("mefo", ["getSectionBookPages"]),
    showVirtualKeyBoard() {
      const react = this.$store.state.inputKeyboardChange;
      return localStorage.getItem("virtualKeyBoard") == "1";
    },
    freeSearchBookListStore() {
      return createFreeSearchBookListStore(this.searchId);
    },

    getTextInput() {
      return this.freeSearchBookListStore?.textInput || "";
    },
    getSearchInType() {
      return this.freeSearchBookListStore.searchInType;
    },
    getFreeSearchSearchInType() {
      return this.freeSearchBookListStore.searchInType;
    },
    setFocusInInput() {
      return this.freeSearchBookListStore?.focusInInput || false;
    },
  },
  methods: {
    ...mapActions("vKeyBoard", [
      "setKeyBoardDisplay",
      "setKeyBoardInputName",
      "setKeyBoardInput",
    ]),
    ...mapActions("freeSearch", [
      "setSearchString",
      "setSearchProgress",
      "setSearching",
      "setShowAdvPopup",
    ]),
    ...mapActions("freeSearchBooklistComp", ["checkAllListBooksFree"]),
    ...mapActions("booklistComp", ["setFirstFreeActive"]),
    setInputTxt(val) {
      this.freeSearchBookListStore.setTextInput(val);
    },
    setFreeSearchSearchInType(val) {
      this.freeSearchBookListStore.setSearchInType(val);
    },
    setCurrentSearchInType(val) {
      this.freeSearchBookListStore.setCurrentSearchInType(val);
    },
    updateCursorPosition(event) {
      // Update the cursor position
      this.cursorPosition = event.target.selectionStart;
    },
    handleKeydown_moved_to_mixin(event) {
      if (!event.getModifierState("CapsLock") && keyCodeMap[event.keyCode]) {
        // Prevent the default behavior
        event.preventDefault();

        // Insert the Hebrew character at the current cursor position
        const hebrewChar = keyCodeMap[event.keyCode];
        const start = event.target.selectionStart;
        const end = event.target.selectionEnd;

        const inputVal = this.$refs.input.value;
        this.$refs.input.value =
          inputVal.slice(0, start) + hebrewChar + inputVal.slice(end);

        // Update cursor position to be after the inserted character
        this.$nextTick(() => {
          this.$refs.input.setSelectionRange(start + 1, start + 1);
        });
      }
    },
    setVKB(showKB = true) {
      this.setKeyBoardInputName(this.$refs.input.id);
      if (showKB) this.setKeyBoardDisplay(true);
    },
    clearTxt() {
      this.clear();
      this.inputEmpty = true;
      this.setKeyBoardInput("");
      this.$refs.input.focus();
    },
    toggleFocus() {
      let t = this;
      setTimeout(() => {
        if (t.$refs.input == undefined) return;
        if (t.$refs.input.value != "") {
          t.inputEmpty = false;
        } else t.inputEmpty = true;
        t.isFocus = !t.isFocus;
        t.$emit("focus", t.isFocus);
      }, 500);
      this.setVKB(false);
    },
    setSearchWords(event, str) {
      if (event) {
        let txt = event.target.value.replace(/\s\s$/g, "-");

        this.setKeyBoardInput(txt);
        this.setSearchString(txt);

        this.setInputTxt(txt);
        this.inputEmpty = txt.length == 0;
      } else {
        let txt = str.replace(/\s\s$/g, "-");

        this.setSearchString(txt);

        this.setInputTxt(txt);
        this.inputEmpty = txt.length == 0;
      }
    },
    scrollList(event) {
      switch (event.code) {
        case "ArrowDown":
        case "Numpad2":
          this.setFirstFreeActive(new Date().getMilliseconds());

          break;

        case "Tab":
          event.preventDefault();
          event.stopPropagation();
          if (event.shiftKey) {
            this.$store.dispatch("tabsManager/goToNextTab");
            break;
          }
          let bookElement = document.getElementById(
            `the-book${this.$store.state.tabsManager.currentTabId}`
          );
          if (bookElement) bookElement.focus();
          break;
        case "F2":
          event.preventDefault();
          event.stopPropagation();
          this.$store.state.bookList.setFocusInInput++;
          break;
        case "F3":
          event.preventDefault();
          event.stopPropagation();
          this.freeSearchBookListStore.focusInInput++;
          break;
      }
      if (!this.isSpecialKeys(event)) {
        this.handleKeydown(event, this.$refs.input);
        this.setSearchWords(event);
      }
    },
    setTxt(value) {
      this.searchText = value;
    },

    async doFreeSearch1() {
      let txtToSearch = this.$refs.input.value
        .trim()
        .replace(/[\u0591-\u05C7]/g, ""); //remove niqud
      if (txtToSearch == "") return;
      let books = [];
      if (this.mefo) {
        setSearchType("mefo");

        this.searchMefo(txtToSearch);
        return;
      }
      books = await this.getBooksToSearchIn();
      let searchInType = this.getSearchInType;
      searchInType === this.enumSearchInType.tsiyunim
        ? setSearchType("special")
        : setSearchType("classic");
      this.doFreeSearch(txtToSearch, books);
      return;
    },
    searchMefo(txtToSearch) {
      this.$store.state.freeSearch.inBook = false;

      if (txtToSearch != "") {
        const currentSection =
          this.$store.state.tabs[this.currentTabId].shasSecSelected;
        if (!currentSection[0]) return false;

        const listType = `mefo_${currentSection[0].id}`;
        this.setFreeSearchSearchInType(listType);
        this.setCurrentSearchInType(listType);
        setSearchType("mefo");

        const booksPages = Object.assign(
          {},
          this.getSectionBookPages.get(currentSection[0].id)
        );

        Object.keys(booksPages).forEach(
          (bp) => (booksPages[bp] = booksPages[bp].pages)
        );
        let books = {
          id: 1,
          books: booksPages,
          mefOtzar: true,
        };

        this.doFreeSearch(
          txtToSearch.replace(/[\u0591-\u05C7]/g, ""), //remove niqud,
          books,
          0,
          false
        )
          .then(() => {
            this.$emit("search", {
              show: false,
              txt: txtToSearch,
            });
          })
          .catch((err) => console.log(err));
      }
    },
  },
  mounted() {
    this.$refs.input.id = `fs_input_${Math.random(1 % 10000000)}`;
  },
  watch: {
    setFocusInInput: function () {
      if (this.$refs.input) this.$refs.input.focus();
    },
    vKeyBoardInput: function (val) {
      if (this.$refs.input.id == this.vKeyBoardInputName) {
        this.setSearchWords(null, val);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$bg-hover1: #00000014;
$bg-hover2: #00000020;
$bg-active2: #00000030;
$bg-color1: #fff;
$text-color1: #000;

$text-color: #fff;
.div-input {
  padding: 12px 12px 0 0px;
  position: relative;
  flex-grow: 1;
  // display: flex;
  align-items: center;
}
.icon-search,
.icon-clear {
  // height: 100%;
  /* width: 25px; */
  position: absolute;
  left: 7px;
  height: 20.3px;
  top: 5px;
  z-index: 2;
  position: absolute;
  /* padding: 5px 6px; */
  border-radius: 50%;
  display: flex;
  align-items: center;
  color: var(--custom-color1);
}
.icon-clear {
  // position: absolute;
  top: 6px;
  // transform: translateY(-50%);
  font-size: 9px;
  left: 55px;
  color: var(--text-color2);
  cursor: pointer;
  // width: 26px;
  // height: 26px;
  // padding: 3px 9px;
  // border-radius: 50%;
  &:hover {
    color: var(--text-color1);
  }
}
.hh-circle {
  cursor: pointer;
  &:hover::before {
    background-color: rgba(32, 33, 36, 0.059);
    border: none;
    box-shadow: none;
    opacity: 1;
    transform: scale(1);
  }
  &::before {
    // content: "";
    // display: block;
    opacity: 0;
    position: absolute;
    transition-duration: 0.25s;
    transition-timing-function: cubic-bezier(0.8, 0, 0.2, 1);
    cursor: pointer;
    // z-index: -1;
    background: none;
    border-radius: 50%;
    box-sizing: border-box;
    transform: scale(0);
    transition-property: transform, opacity;
    height: 26px;
    width: 26px;
    top: 0;
    left: 0;
    right: auto;
  }
  &:active {
    background-color: $bg-active2;
  }
  &:active::before {
    border: none;
    box-shadow: none;
    opacity: 1;
    transform: scale(1.5);
    background-color: $bg-hover1;
  }
}
input {
  height: 30.54px;
  border-radius: 0 !important;
  border-top-left-radius: 15px !important;
  border-bottom-left-radius: 15px !important;
  width: 100%;
  background-color: $bg-color1;
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 16px;
  font-weight: bold;
  color: $text-color1;
  padding: 0 35px 0 22px;
  outline: 0;
  &.input-search {
    text-align: right;
    direction: rtl;
  }
}
input:focus {
  border: 1px solid rgba(0, 0, 0, 0.5);
}
input::placeholder {
  // font-size: 16px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.4);
}
.keyboard-icon {
  position: absolute;
  left: 30px;
  top: 5px;
  cursor: pointer;
}
.mefo {
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}
</style>
